import axios from 'axios'
import CONFIG from '../config.js'

import takeFirstResult from '@/api/util/takeFirstResult'
import flattenACF from '@/api/util/flattenACF'
import transformOptions from '@/api/util/transformOptions'

export default function getOptions (lang = 'de-ch') {
	return axios.get(`${CONFIG.API_URL}/acf/v3/options/options?lang=${lang === 'en-us' ? 'en' : 'de'}`, {
		transformResponse: [].concat(
			axios.defaults.transformResponse,
			flattenACF,
			transformOptions
		)
	}).then((response) => {
		// console.log(response.data)
		return response
	})
}



// WEBPACK FOOTER //
// ./src/api/options.wp.api.js